import { useTranslation } from 'react-i18next';
import { canReview } from '../../utils/stateHelpers';
import { timeAgo } from '../../utils/timeAgo';
import TagStatus from '../common/TagStatus';
import styles from './StoryCard.module.css';

export default function StoryCard({ story, onClick, className }) {
  const { t } = useTranslation();
  const isUnreviewed = canReview(story);
  const isUnread = story?.status === 'unread';
  const dateLabel = story.created_at ? timeAgo(story.created_at) : '';

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.storyCard}${className ? ` ${className}` : ''}`}
      aria-label={`${story.title || t('bookshelf.untitledStory')}${isUnreviewed ? ' - unreviewed' : ''}`}
    >
      {story.image_url ? (
        <>
          <div
            className={styles.storyCardBg}
            style={{ backgroundImage: `url(${story.image_url})` }}
          />
          <div className={styles.storyCardOverlay} />
        </>
      ) : (
        <div className={styles.storyCardBgFallback} />
      )}

      <div className={styles.storyCardContent}>
        <div className={styles.storyCardHeader}>
          <p className={styles.storyCardTitle}>
            {story.title || t('bookshelf.untitledStory')}
          </p>
          {dateLabel && (
            <div className={styles.storyCardMeta}>
              <span className={styles.storyCardDate}>{dateLabel}</span>
            </div>
          )}
        </div>
        {isUnread && <TagStatus status="unread" />}
        {isUnreviewed && <TagStatus status="unreviewed" />}
      </div>
    </button>
  );
}
